export class Question
{

  questions;

  constructor(questions) {
    this.questions = questions;
  }

  for(type) {
    let formatted = [];
    switch(type) {
      case 'summary':
        formatted = this.formatSummary();
        break;
      default:
        formatted = [];
        break;
    }
    return formatted;
  }

  formatSummary() {
    let holder = {};
    for (const question of this.questions) {
      holder[question.id] = {
        id: question.id,
        text: question.question_text,
        isChecked: false,
        isRequired: question.is_mandatory
      };
      if (question.options.length) {
        holder[question.id]['options'] = {};
        for (const option of question.options) {
          holder[question.id]['options'][option.id] = {
            id: option.id,
            text: option.question_text,
            answer: '',
            type: option.type,
            isRequired: option.mandatory
          }
        }
      }
    }

    return holder;
  }

};
